import * as swcHelpers from '@swc/helpers';
import { Types, Utils } from '@grandvisionhq/auth';

const toSavedOptIns = (rawOptIns)=>{
    if (!rawOptIns) {
        return {};
    }
    var _value;
    return rawOptIns.reduce((result, optIn)=>swcHelpers.objectSpread({}, result, {
            [optIn.id]: (_value = optIn.value) !== null && _value !== void 0 ? _value : false
        })
    , {});
};
const getShownOptIns = (allOptIns, savedOptIns)=>{
    if (!Object.keys(savedOptIns).length) {
        return allOptIns;
    }
    // previously selected opt ins
    const alreadySelectedOptIns = Object.keys(savedOptIns).filter((key)=>savedOptIns[key]
    );
    return allOptIns.filter((optIn)=>{
        if (!Types.isGroupedOptin(optIn)) {
            return !alreadySelectedOptIns.includes(optIn.value);
        }
        const ungroupedOptIns = Utils.ungroupOptIns([
            optIn
        ]);
        // filter through the nested optins to see if they are selected
        return ungroupedOptIns.some((o)=>!alreadySelectedOptIns.includes(o.value)
        );
    });
};
const createOptIn = (optIn, checked, getLabel)=>{
    return {
        [optIn.value]: {
            label: getLabel(optIn.titleKey) || optIn.value,
            checked
        }
    };
};
const toChangedOptIns = (optIns, savedOptIns, selectedOptIns, getLabel)=>{
    const ungroupOptIn = (optIn1, isSelected)=>{
        return Utils.ungroupOptIns([
            optIn1
        ]).filter((optIn)=>{
            const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn.value);
            // do not save again if was previously selected and saved in the backend,
            // but has not additionally opted in the frontend. this is done to not reset previous MYA settings by overwriting them here
            if (isPreviouslySaved && savedOptIns[optIn.value] === true && isSelected === false) {
                return false;
            }
            // save optins that have been changed
            return savedOptIns[optIn.value] !== isSelected;
        }).map((optIn)=>{
            const isChecked = isSelected || savedOptIns[optIn.value] || false;
            return createOptIn(optIn, isChecked, getLabel);
        }).reduce((prev, curr)=>swcHelpers.objectSpread({}, prev, curr)
        , {});
    };
    const toChangedOptIn = (optIn)=>{
        const isSelected = Boolean(selectedOptIns.find((o)=>o.titleKey === optIn.titleKey
        ));
        if (Types.isGroupedOptin(optIn)) {
            return ungroupOptIn(optIn, isSelected);
        }
        const shownOptIns = getShownOptIns(optIns, savedOptIns);
        const isHidden = !Boolean(shownOptIns.find((s)=>s.titleKey === optIn.titleKey
        ));
        if (isHidden) {
            return;
        }
        const isPreviouslySaved = Object.keys(savedOptIns).includes(optIn.value);
        const changedFromPreviouslySaved = savedOptIns[optIn.value] !== isSelected;
        if (isPreviouslySaved && !changedFromPreviouslySaved) {
            // do not save previously saved, but unchanged items
            return;
        }
        const isChecked = isSelected || savedOptIns[optIn.value] || false;
        return createOptIn(optIn, isChecked, getLabel);
    };
    return optIns.reduce((result, optIn)=>{
        return swcHelpers.objectSpread({}, result, toChangedOptIn(optIn));
    }, {});
};

export { getShownOptIns, toChangedOptIns, toSavedOptIns };
//# sourceMappingURL=opt-ins.js.map
